/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'licensing-page-header';
const prefix = `${moduleName}.${componentName}`;

export const unlockMoreFeaturesMessage = `${prefix}.unlockMoreFeaturesMessage`;
export const licensingLabel = `${prefix}.licensingLabel`;
export const editSettingsLabel = `${prefix}.editSettingsLabel`;
export const overviewTabLabel = `${prefix}.overviewTabLabel`;
export const tenantUsageTabLabel = `${prefix}.tenantUsageTabLabel`;
export const disconnectedLabel = `${prefix}.disconnectedLabel`;

export const ENGLISH = {
    [unlockMoreFeaturesMessage]: 'Unlock more features and possibilities with Enterprise edition.',
    [licensingLabel]: 'Licensing',
    [editSettingsLabel]: 'EDIT SETTINGS',
    [overviewTabLabel]: 'Overview',
    [tenantUsageTabLabel]: 'Tenant Usage',
    [disconnectedLabel]: 'Disconnected',
};
